var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-block',[_c('template',{slot:"header"},[_c('h2',[_vm._v("In this section")])]),(_vm.links)?_c('nav',{staticClass:"c-page-nav"},[_c('page-navigation-list',{attrs:{"links":_vm.links}})],1):_c('loading')],2)}
var staticRenderFns = []

export { render, staticRenderFns }